import { defineComponent, computed, openBlock, createElementBlock, Fragment, renderList, renderSlot, createBlock, resolveDynamicComponent, mergeProps } from "vue";
import { Node, generateHTML } from "@tiptap/core";
import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import Image from "@tiptap/extension-image";
import Highlight from "@tiptap/extension-highlight";
import Link from "@tiptap/extension-link";
import Table from "@tiptap/extension-table";
import TableRow from "@tiptap/extension-table-row";
import TableCell from "@tiptap/extension-table-cell";
import TableHeader from "@tiptap/extension-table-header";
var Embed = Node.create({
  name: "embed",
  group: "block",
  atom: true,
  defaultOptions: {
    allowFullscreen: true,
    HTMLAttributes: {
      class: "iframe-wrapper"
    }
  },
  addAttributes() {
    return {
      src: {
        default: null
      },
      frameborder: {
        default: 0
      },
      allowfullscreen: {
        default: "allowfullscreen"
      },
      allow: {
        default: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      },
      "data-type": {
        default: null
      },
      loading: {
        default: "lazy"
      },
      "data-id": {
        default: null
      }
    };
  },
  renderHTML({ HTMLAttributes }) {
    return ["div", this.options.HTMLAttributes, ["iframe", HTMLAttributes]];
  }
});
function mergeObjects$1(objects) {
  const obj = {};
  objects.forEach((cur, index) => {
    if (cur) {
      if (index === 0) {
        Object.assign(obj, cur);
      } else {
        Object.entries(cur).forEach(([key, value]) => {
          if (obj[key]) {
            if (typeof obj[key] === "string") {
              obj[key] += ` ${value}`;
            } else if (typeof obj[key] === "object") {
              obj[key] = mergeObjects$1([obj[key], value]);
            }
          } else {
            obj[key] = value;
          }
        });
      }
    }
  });
  return obj;
}
function objectToAttributes$1(data) {
  return Object.entries(data).reduce((acc, [key, value]) => {
    acc += `${key}="${value}" `;
    return acc;
  }, "");
}
function attributesToObject$1(attributeString) {
  if (typeof attributeString !== "string" || !attributeString) {
    return {};
  }
  const attributeMatches = [...attributeString.matchAll(/(?:([a-zA-Z-_]+)="([^"]+)")/g)];
  return attributeMatches.reduce((acc, cur) => {
    acc[cur[1]] = cur[2];
    return acc;
  }, {});
}
function getCustomNodeAttributes$1(data) {
  switch (data.type) {
    case "image": {
      const attrs = { class: "" };
      if (data.attrs.size) {
        attrs.class += `richtext__imagesize--${data.attrs.size} `;
      }
      if (data.attrs.float) {
        attrs.class += `richtext__imagefloat--${data.attrs.float} `;
      }
      return attrs;
    }
    default:
      return {};
  }
}
function getBlockSettings$1(data, settings = {}, index) {
  var _a;
  const typeSettings = settings[data.type];
  const typeIndexSettings = index && typeSettings ? (_a = typeSettings.index) == null ? void 0 : _a[index] : void 0;
  const blockSettings = typeIndexSettings || typeSettings || {};
  if (settings.attrs) {
    return mergeObjects$1([blockSettings, settings.attrs ? { attrs: settings.attrs } : {}]);
  }
  return blockSettings;
}
function wrapOutput$1(data, blockSettings) {
  if (data) {
    if (blockSettings.wrap.tag) {
      const wrapAttrs = blockSettings.wrap.attrs ? objectToAttributes$1(blockSettings.wrap.attrs) : "";
      data += `</${blockSettings.wrap.tag}>`;
      data = `<${blockSettings.wrap.tag} ${wrapAttrs}>${data}</${blockSettings.wrap.tag}>`;
    } else if (blockSettings.wrap.html) {
      data = blockSettings.wrap.html.replace("$1", data);
    }
  }
  return data;
}
function getOpeningTag$1(html) {
  return html.match(/^(<([^>\s]+)[ ]*([^>]+)*)>/);
}
function applyAttributes$1(data, block, blockSettings) {
  const openingTag = getOpeningTag$1(data);
  if (openingTag) {
    const existingAttributes = openingTag[3] ? attributesToObject$1(openingTag[3]) : void 0;
    const customNodeAttributes = getCustomNodeAttributes$1(block);
    const mergedAttributes = mergeObjects$1([
      existingAttributes,
      customNodeAttributes,
      blockSettings.attrs
    ]);
    const attrHtml = objectToAttributes$1(mergedAttributes);
    data = data.replace(openingTag[1], `<${openingTag[2]} ${attrHtml}`);
  }
  return data;
}
function getBlockHTML$1(data, settings = {}, index) {
  try {
    let html = generateHTML({ type: "doc", content: [data] }, [
      StarterKit,
      Underline,
      Image,
      Link,
      Embed,
      Highlight,
      Table,
      TableRow,
      TableCell,
      TableHeader
    ]);
    const blockSettings = getBlockSettings$1(data, settings, index);
    if (blockSettings.attrs) {
      html = applyAttributes$1(html, data, blockSettings);
    }
    if (blockSettings.wrap) {
      html = wrapOutput$1(html, blockSettings);
    }
    return html;
  } catch (err) {
    console.debug(err);
    return "<div></div>";
  }
}
function getBlockRenderData$1(data, settings = {}, index) {
  const html = getBlockHTML$1(data, settings, index);
  const tag = getOpeningTag$1(html);
  let content = "";
  if (!html.endsWith("/>")) {
    content = html.replace(tag[0], "");
    const lastClosingTag = content.lastIndexOf("</");
    if (lastClosingTag > -1) {
      content = content.slice(0, lastClosingTag);
    }
  }
  return {
    tag: tag[2],
    attributes: attributesToObject$1(tag[3]),
    content,
    block: data
  };
}
var RichText_vue_vue_type_style_index_0_lang = "";
var _export_sfc = (sfc, props) => {
  for (const [key, val] of props) {
    sfc[key] = val;
  }
  return sfc;
};
const _sfc_main = defineComponent({
  name: "Richtext",
  props: {
    data: {
      type: Object
    },
    settings: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    const blocks = computed(() => {
      if (props.data && props.data.content) {
        return props.data.content.map((block, i) => getBlockRenderData$1(block, props.settings, i));
      }
      return [];
    });
    return {
      blocks
    };
  }
});
const _hoisted_1 = { class: "richtext" };
const _hoisted_2 = { key: 1 };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1, [
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.blocks, (block, index) => {
      return renderSlot(_ctx.$slots, block.block.type, {
        key: index,
        block: block.block
      }, () => [
        block.tag ? (openBlock(), createBlock(resolveDynamicComponent(block.tag), mergeProps({
          key: 0,
          class: ["richtext--" + block.block.type]
        }, block.attributes, {
          innerHTML: block.content
        }), null, 16, ["class", "innerHTML"])) : (openBlock(), createElementBlock("div", _hoisted_2, "Could not render block"))
      ]);
    }), 128))
  ]);
}
var RichText = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
function mergeObjects(objects) {
  const obj = {};
  objects.forEach((cur, index) => {
    if (cur) {
      if (index === 0) {
        Object.assign(obj, cur);
      } else {
        Object.entries(cur).forEach(([key, value]) => {
          if (obj[key]) {
            if (typeof obj[key] === "string") {
              obj[key] += ` ${value}`;
            } else if (typeof obj[key] === "object") {
              obj[key] = mergeObjects([obj[key], value]);
            }
          } else {
            obj[key] = value;
          }
        });
      }
    }
  });
  return obj;
}
function objectToAttributes(data) {
  return Object.entries(data).reduce((acc, [key, value]) => {
    acc += `${key}="${value}" `;
    return acc;
  }, "");
}
function attributesToObject(attributeString) {
  if (typeof attributeString !== "string" || !attributeString) {
    return {};
  }
  const attributeMatches = [...attributeString.matchAll(/(?:([a-zA-Z-_]+)="([^"]+)")/g)];
  return attributeMatches.reduce((acc, cur) => {
    acc[cur[1]] = cur[2];
    return acc;
  }, {});
}
function getCustomNodeAttributes(data) {
  switch (data.type) {
    case "image": {
      const attrs = { class: "" };
      if (data.attrs.size) {
        attrs.class += `richtext__imagesize--${data.attrs.size} `;
      }
      if (data.attrs.float) {
        attrs.class += `richtext__imagefloat--${data.attrs.float} `;
      }
      return attrs;
    }
    default:
      return {};
  }
}
function getBlockSettings(data, settings = {}, index) {
  var _a;
  const typeSettings = settings[data.type];
  const typeIndexSettings = index && typeSettings ? (_a = typeSettings.index) == null ? void 0 : _a[index] : void 0;
  const blockSettings = typeIndexSettings || typeSettings || {};
  if (settings.attrs) {
    return mergeObjects([blockSettings, settings.attrs ? { attrs: settings.attrs } : {}]);
  }
  return blockSettings;
}
function wrapOutput(data, blockSettings) {
  if (data) {
    if (blockSettings.wrap.tag) {
      const wrapAttrs = blockSettings.wrap.attrs ? objectToAttributes(blockSettings.wrap.attrs) : "";
      data += `</${blockSettings.wrap.tag}>`;
      data = `<${blockSettings.wrap.tag} ${wrapAttrs}>${data}</${blockSettings.wrap.tag}>`;
    } else if (blockSettings.wrap.html) {
      data = blockSettings.wrap.html.replace("$1", data);
    }
  }
  return data;
}
function getOpeningTag(html) {
  return html.match(/^(<([^>\s]+)[ ]*([^>]+)*)>/);
}
function applyAttributes(data, block, blockSettings) {
  const openingTag = getOpeningTag(data);
  if (openingTag) {
    const existingAttributes = openingTag[3] ? attributesToObject(openingTag[3]) : void 0;
    const customNodeAttributes = getCustomNodeAttributes(block);
    const mergedAttributes = mergeObjects([
      existingAttributes,
      customNodeAttributes,
      blockSettings.attrs
    ]);
    const attrHtml = objectToAttributes(mergedAttributes);
    data = data.replace(openingTag[1], `<${openingTag[2]} ${attrHtml}`);
  }
  return data;
}
function getBlockHTML(data, settings = {}, index) {
  try {
    let html = generateHTML({ type: "doc", content: [data] }, [
      StarterKit,
      Underline,
      Image,
      Link,
      Embed,
      Highlight,
      Table,
      TableRow,
      TableCell,
      TableHeader
    ]);
    const blockSettings = getBlockSettings(data, settings, index);
    if (blockSettings.attrs) {
      html = applyAttributes(html, data, blockSettings);
    }
    if (blockSettings.wrap) {
      html = wrapOutput(html, blockSettings);
    }
    return html;
  } catch (err) {
    console.debug(err);
    return "<div></div>";
  }
}
function getBlockRenderData(data, settings = {}, index) {
  const html = getBlockHTML(data, settings, index);
  const tag = getOpeningTag(html);
  let content = "";
  if (!html.endsWith("/>")) {
    content = html.replace(tag[0], "");
    const lastClosingTag = content.lastIndexOf("</");
    if (lastClosingTag > -1) {
      content = content.slice(0, lastClosingTag);
    }
  }
  return {
    tag: tag[2],
    attributes: attributesToObject(tag[3]),
    content,
    block: data
  };
}
export { RichText as default, getBlockHTML, getBlockRenderData };
